export function isType (of) {
    return of.constructor.name.toLowerCase();
}



// WEBPACK FOOTER //
// ./project/client/src/core/lib/types.js